import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { QuickBooksService } from '../../services/quick-books.service';
import * as QuickbooksActions from '../actions/quickbooks.actions';



@Injectable()
export class QuickbooksEffects {

  loadQuickbooks$ = createEffect(() => {
    return this._actions.pipe( 

      ofType(QuickbooksActions.loadQuickbooks),
      concatMap(() =>
        /** An EMPTY observable only emits completion. Replace with your own observable API request */
        EMPTY.pipe(
          map(data => QuickbooksActions.loadQuickbooksSuccess({ data })),
          catchError(error => of(QuickbooksActions.loadQuickbooksFailure({ error }))))
      )
    );
  });

  loadMostRecent$ = createEffect(() => {
    return this._actions.pipe( 

      ofType(QuickbooksActions.loadMostRecent),
      concatMap(() =>
        /** An EMPTY observable only emits completion. Replace with your own observable API request */
        this._quickbooks.getMostRecent().pipe(
          map(data => {
            return QuickbooksActions.loadMostRecentSuccess({ data })
          }),
          catchError(error => of(QuickbooksActions.loadMostRecentFailure({ error }))))
      )
    );
  });

    loadSyncs$ = createEffect(() => {
    return this._actions.pipe( 

      ofType(QuickbooksActions.loadSyncs),
      concatMap(() =>
        /** An EMPTY observable only emits completion. Replace with your own observable API request */
        this._quickbooks.getSyncs().pipe(
          map(({ data }: any)=> {
            return QuickbooksActions.loadSyncsSuccess({ payload: data.syncs })
          }),
          catchError(error => of(QuickbooksActions.loadSyncsFailure({ error }))))
      )
    );
  });



  constructor(private _actions: Actions, private _quickbooks: QuickBooksService) {}

}
